/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venueflyertagline2Inputs */

const en_venueflyertagline2 = /** @type {(inputs: Venueflyertagline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan, check in and let your friends know you're here.`)
};

const de_venueflyertagline2 = /** @type {(inputs: Venueflyertagline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan, check ein und lass deine Freunde wissen, dass ihr hier seid.`)
};

/**
* | output |
* | --- |
* | "Scan, check in and let your friends know you're here." |
*
* @param {Venueflyertagline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueflyertagline2 = /** @type {((inputs?: Venueflyertagline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueflyertagline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueflyertagline2(inputs)
	return de_venueflyertagline2(inputs)
});
export { venueflyertagline2 as "venueFlyerTagline" }